import { Badge, isRawRank, RankBadge } from "@tcg/ui";
import { useTranslation } from "react-i18next";

import { gradeLabel, isSealed, type GradingInfo } from "./labels";

export interface ItemBadgesProps {
  productType: string | null | undefined;
  rawRank?: string | null;
  grading?: GradingInfo | null;
  consigned?: boolean;
  consignedRef?: string | null;
  size?: "sm" | "md" | "lg";
}

/**
 * What kind of card this is, on every tile and basket line (R16): raw → the shop's Rank A–D
 * (always — CLAUDE.md), graded → 「PSA 10」, sealed → 「未開封」, consigned → 「委託」.
 */
export function ItemBadges({
  productType,
  rawRank,
  grading,
  consigned,
  consignedRef,
  size = "md",
}: ItemBadgesProps) {
  const { t } = useTranslation();
  const grade = gradeLabel(grading);
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      {productType === "raw_single" && isRawRank(rawRank) ? (
        <RankBadge rank={rawRank} label={t(`rank.${rawRank}`)} size={size} />
      ) : null}
      {grade ? (
        <Badge variant="outline" className="text-sm font-semibold">
          {grade}
        </Badge>
      ) : null}
      {isSealed(productType) ? <Badge variant="outline">{t("tile.sealed")}</Badge> : null}
      {consigned ? (
        <Badge variant="pending">
          {consignedRef ? t("cart.consigned_ref", { ref: consignedRef }) : t("tile.consigned")}
        </Badge>
      ) : null}
    </span>
  );
}
